import { gql } from "@apollo/client";

const GET_BOOKING_APPOINTMENT = gql`
  query GetAppointment {
    me {
      currentLevel {
        id
      }
      spokenOnly
      charactersPreference
      credits
    }
  }
`;

export default GET_BOOKING_APPOINTMENT;
